import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5915d9ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  id: "replenish",
  class: "box_sso replenish"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_table" }
const _hoisted_4 = { class: "cell" }
const _hoisted_5 = { class: "text_bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_result = _resolveComponent("a-result")!
  const _component_SSOBackground = _resolveComponent("SSOBackground")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_IdcardOutlined = _resolveComponent("IdcardOutlined")!
  const _component_TeamOutlined = _resolveComponent("TeamOutlined")!
  const _component_SolutionOutlined = _resolveComponent("SolutionOutlined")!
  const _component_MailOutlined = _resolveComponent("MailOutlined")!
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!

  return ($data.request.intercept.check||$data.request.data.isWrite)
    ? (_openBlock(), _createBlock(_component_a_result, {
        key: 0,
        class: "box_result",
        status: "info",
        title: "正在登录",
        "sub-title": "用户信息校验中..."
      }))
    : (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_component_SSOBackground),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createCommentVNode("<a-col :xs=\"24\" :lg=\"!$Store.User().isHideMsg?12:24\">"),
                  _createVNode(_component_a_col, { xs: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form, {
                        ref: "form",
                        model: $data.form.data,
                        rules: $data.form.rule
                      }, {
                        default: _withCtx(() => [
                          _createCommentVNode("<i class=\"logo\" />"),
                          _createVNode(_component_a_typography_title, { level: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 完善信息 ")
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createCommentVNode("<a-typography-title :level=\"2\">"),
                          _createCommentVNode("    现在注册应用市场，<br v-if=\"$Store.Public().isGridMatch('<',$Enum.GridEnum.LG)\" />即刻免费体验30分钟AI应用"),
                          _createCommentVNode("</a-typography-title>"),
                          _createVNode(_component_a_form_item, {
                            name: "name",
                            "has-feedback": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: $data.form.data.name,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($data.form.data.name) = $event)),
                                placeholder: "用户名",
                                maxlength: _ctx.$Check.Constraint.Max,
                                "show-count": $data.form.data.name.length>0,
                                "allow-clear": ""
                              }, {
                                prefix: _withCtx(() => [
                                  _createVNode(_component_UserOutlined, { class: "input_icon" })
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["value", "maxlength", "show-count"])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createCommentVNode("<a-row justify=\"center\">"),
                          _createCommentVNode("    <a-col :xs=\"24\" :sm=\"20\">"),
                          _createCommentVNode("        <a-divider dashed />"),
                          _createCommentVNode("        <a-typography-paragraph>"),
                          _createCommentVNode("            为了更好的为您服务，请补充填写相关信息"),
                          _createCommentVNode("        </a-typography-paragraph>"),
                          _createCommentVNode("    </a-col>"),
                          _createCommentVNode("</a-row>"),
                          _createVNode(_component_a_form_item, {
                            name: "real_name",
                            "has-feedback": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: $data.form.data.real_name,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($data.form.data.real_name) = $event)),
                                placeholder: "姓名",
                                maxlength: _ctx.$Check.Constraint.RealNameMax,
                                "show-count": $data.form.data.real_name.length>0,
                                "allow-clear": ""
                              }, {
                                prefix: _withCtx(() => [
                                  _createVNode(_component_IdcardOutlined, { class: "input_icon" })
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["value", "maxlength", "show-count"])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_a_form_item, {
                            name: "ent_name",
                            "has-feedback": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: $data.form.data.ent_name,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($data.form.data.ent_name) = $event)),
                                placeholder: "企业/学校",
                                maxlength: _ctx.$Check.Constraint.MaxX,
                                "show-count": $data.form.data.ent_name.length>0,
                                "allow-clear": ""
                              }, {
                                prefix: _withCtx(() => [
                                  _createVNode(_component_TeamOutlined, { class: "input_icon" })
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["value", "maxlength", "show-count"])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_a_form_item, {
                            name: "position",
                            "has-feedback": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: $data.form.data.position,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($data.form.data.position) = $event)),
                                placeholder: "职位",
                                maxlength: _ctx.$Check.Constraint.MaxX,
                                "show-count": $data.form.data.position.length>0,
                                "allow-clear": ""
                              }, {
                                prefix: _withCtx(() => [
                                  _createVNode(_component_SolutionOutlined, { class: "input_icon" })
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["value", "maxlength", "show-count"])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_a_form_item, {
                            name: "email",
                            "has-feedback": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_auto_complete, {
                                value: $data.form.data.email,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($data.form.data.email) = $event)),
                                options: $data.expand.mail,
                                "onUpdate:options": _cache[5] || (_cache[5] = ($event: any) => (($data.expand.mail) = $event)),
                                onSearch: _cache[6] || (_cache[6] = mail=>$data.expand.mail=_ctx.$FN.FormatMail(mail)),
                                onSelect: _cache[7] || (_cache[7] = mail=>$data.form.data.email=mail)
                              }, {
                                option: _withCtx(({ value }) => [
                                  _createTextVNode(_toDisplayString(value.split('@')[0]) + " ", 1 /* TEXT */),
                                  _createElementVNode("span", _hoisted_5, " @ " + _toDisplayString(value.split('@')[1]), 1 /* TEXT */)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    placeholder: "邮箱",
                                    maxlength: _ctx.$Check.Constraint.Max2X,
                                    "show-count": $data.form.data.email.length>0,
                                    "allow-clear": ""
                                  }, {
                                    prefix: _withCtx(() => [
                                      _createVNode(_component_MailOutlined, { class: "input_icon" })
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["maxlength", "show-count"])
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["value", "options"])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_a_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    loading: $data.request.intercept.submit,
                                    onClick: $options.submit,
                                    block: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 提交 ")
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["loading", "onClick"])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["model", "rules"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createCommentVNode("<a-col v-if=\"$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)&&!$Store.User().isHideMsg\""),
                  _createCommentVNode("       :xs=\"24\" :lg=\"12\">"),
                  _createCommentVNode("  <SSOIntroduce />"),
                  _createCommentVNode("</a-col>")
                ]),
                _: 1 /* STABLE */
              })
            ])
          ])
        ])
      ]))
}